var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumpy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4dabcf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.048 7.689-4.643-2.362-5.096 2.563 4.769 2.413z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.177 8.771 4.868 2.476-5.051 2.556-4.776-2.417z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.678 5.363 5.001 2.527-4.472 2.263-4.879-2.479z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.526 4.274-4.503-2.274-4.453 2.239 4.639 2.358z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.006 23.809v6.191l5.454-2.742-.006-6.194z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.452 18.903-.006-6.129-5.44 2.725v6.131z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 17.754v6.215l-4.652 2.339-.003-6.186z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 15.581v-6.09l-4.661 2.335.004 6.141z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.08 15.5-3.674-1.861v8.045s-4.493-9.634-4.906-10.499a.9.9 0 0 0 -.331-.264c-.808-.421-3.169-1.631-3.169-1.631v14.21l3.266 1.76v-7.428s4.445 8.607 4.49 8.7a4.026 4.026 0 0 0 .968 1.32c.635.423 3.357 2.073 3.357 2.073z",
    fill: "#4d77cf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumpy);
export default __webpack_public_path__ + "static/media/numpy.6fb9a991659e7c32b00af7534acc3160.svg";
export { ForwardRef as ReactComponent };